import React from "react";
import { Checkbox as MuiRadio } from "@material-ui/core";
import { makeStyles } from "@mui/styles";
import { Row, Col } from "react-flexbox-grid";

const useStyles = makeStyles({
  root: {
    color: "#9FA1A4",
    "&$checked": {
      color: "#F57922",
      "& + $colorBar": {
        backgroundColor: "#FABC90",
        opacity: "1",
      },
    },
  },
  checked: {},
  /*iconCheckbox: {
    borderRadius: '0',
    width: 24,
    height: 24,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIconCheckbox: {
    backgroundColor: '#FFF',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 22,
      height: 22,
      backgroundImage: 'linear-gradient(180deg,var(--button-primary),var(--button-primary))',
      border: '2px solid #BDBDBD',
      borderRadius: '0',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#FFF',
    },
  },*/
});

const ItemCheckbox = ({ id, descripcion, checked, edit }) => {
  const classes = useStyles();

  return (
    <div>
      {((checked && edit) || !edit) && (
        <Row middle="xs" className={`itemCheckbox ${checked && "checked"} ${edit && "edit"}`}>
          <Col xs={2}>
            <MuiRadio
              className={classes.root}
              checked={checked}
              name={id}
              classes={{
                root: classes.root,
                checked: classes.checked,
              }}
              //disabled={true}
              //checkedIcon={<span className={clsx(classes.iconCheckbox, classes.checkedIconCheckbox)} />}
              //icon={<span className={classes.iconCheckbox} />}
            />
          </Col>
          <Col xs={10} style={{ padding: "0px" }}>
            {descripcion}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ItemCheckbox;
